import axiosPost from "../axiosPost";

/**
 * Obtiene los vuelos seleccionables para asignar a un paso de usuario.
 * @param {{ migraUsuarioPasoId: number }} params
 * @param {object} credentials Credenciales del usuario logueado.
 */
export const migraUsuarioPasoVueloGet = async ({ migraUsuarioPasoId }, credentials) => {
    const body = {
        service: "MigraUsuarioPasoVueloGet",
        params: { migraUsuarioPasoId },
    };

    return await axiosPost(body, credentials);
};
